import StringUtil from 'utilities/string_util'

export default class Error {
  constructor([key, message]) {
    this.key = key
    this.message = message
  }
}

export class FieldError {
  constructor(field, message) {
    this.field = field
    this.message = message
  }

  static fromJson(json) {
    return new FieldError(json[0], json[1])
  }

  get uniqueKey() {
    if (this.key) {
      return this.key
    }

    this.key = StringUtil.getRandomString()

    return this.key
  }
}
